var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-spinner",attrs:{"body":""}},[_c('i',{staticClass:"el-icon-loading text-[#FFFFFF] text-[32px]"})])
}
var staticRenderFns = []

export { render, staticRenderFns }